export default "__VITE_ASSET__D4I$VPHZ__"